// extracted by mini-css-extract-plugin
export default {"backgroundGrad":"Trial_backgroundGrad__Suk4r","container":"Trial_container__pTsLE"};